<template>
  <div class="cmp-consent-checkboxes ws-specificity">
    <ws-checkbox
      v-if="forceRequired || !cart.termsAndConditionsConsent"
      v-model="termsAndConditionsConsent"
      class="full-width text-bold cy--consent-checkboxes--tos"
      :path="pathTos"
      :rules="[required]"
    >
      {{ $t('billing_profile.consent_tos.label') }}
      <a
        v-if="termsAndConditionsUrl"
        href="javascript:void(0)"
        target="_blank"
        class="ws-link"
        @click.prevent.stop="goToTos"
      >
        {{ $t('billing_profile.consent_tos.link') }}</a>
    </ws-checkbox>

    <ws-checkbox
      v-if="
        forceRequired ||
          (!isSwedishWorkflow &&
            cart.consentThirdPartyRequired &&
            !cart.thirdPartyConsent)
      "
      v-model="thirdPartyConsent"
      class="full-width text-bold cy--consent-checkboxes--third-party cy-consent-third-party"
      :path="pathThirdParty"
      :rules="[required]"
    >
      {{ $t('third_party.label') }}
      <a
        href="javascript:void(0)"
        class="ws-link"
        @click.prevent.stop="thirdPartyDialog = true"
      >
        {{ $t('third_party.link') }}</a>
    </ws-checkbox>

    <ws-modal
      v-model="thirdPartyDialog"
      :cfg="{ title: 'third_party.dialog.title' }"
    >
      <third-party-info />
    </ws-modal>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';

import { required } from '@/services/validation/validation.service.ts';
import WsCheckbox from '@WS_Components/WsCheckbox.vue';
import WsModal from '@/components/dialogs/WsModal.vue';
import type { Cart } from '@/types';
import config, { isSwedishWorkflow } from '@/services/config.service';
import ThirdPartyInfo from '@/components/ThirdPartyInfo.vue';

@Component({
  components: {
    WsCheckbox,
    WsModal,
    ThirdPartyInfo,
  },

  computed: {
    ...mapState(['cart']),
  },
})
export default class ConsentCheckboxes extends Vue {
  @Prop(Boolean)
  readonly value!: boolean;
  @Prop(Boolean)
  readonly forceRequired!: boolean;
  readonly cart!: Cart;
  thirdPartyDialog = false;
  public termsAndConditionsConsent = false;
  public thirdPartyConsent = false;
  required = required;
  isSwedishWorkflow = isSwedishWorkflow;

  pathTos: string = 'user.personalInformation.tos';
  pathThirdParty: string = 'user.thirdPartyConsent';

  get termsAndConditionsUrl(): string {
    return config.tosUrl;
  }

  public validateCheckboxes() {
    let result = true;

    if (
      (this.forceRequired || !this.cart.termsAndConditionsConsent) &&
      !this.termsAndConditionsConsent
    ) {
      this.$messageService.setStandardMessage(
        'user.personalInformation.tos',
        'validation.consent_tos.required'
      );
      result = false;
    }

    if (
      (this.forceRequired ||
        (!this.isSwedishWorkflow &&
          this.cart.consentThirdPartyRequired &&
          !this.cart.thirdPartyConsent)) &&
      !this.thirdPartyConsent
    ) {
      this.$messageService.setStandardMessage(
        'user.thirdPartyConsent',
        'validation.consent_third_party.required'
      );
      result = false;
    }
    return result;
  }

  @Watch('cart.termsAndConditionsConsent', { immediate: true })
  onTosChanged(consentValue: boolean) {
    this.$messageService.clearMessages(this.pathTos);
    this.termsAndConditionsConsent = !!consentValue;
  }

  @Watch('cart.thirdPartyConsent', { immediate: true })
  on3rdPartyChanged(consentValue: boolean) {
    this.$messageService.clearMessages(this.pathThirdParty);
    this.thirdPartyConsent = !!consentValue;
  }

  public reset() {
    this.termsAndConditionsConsent = false;
    this.thirdPartyConsent = false;
    this.thirdPartyDialog = false;
  }

  goToTos() {
    window.open(this.termsAndConditionsUrl, '_blank');
  }
}
</script>

<style lang="scss" scoped>
.cmp-consent-checkboxes.ws-specificity {
  .ws-checkbox {
    color: $ws-base140;
  }

  .ws-checkbox + .ws-checkbox {
    margin-top: map-get($space-md, y);
  }
}
</style>
